import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';

import {LayoutComponent} from './layouts/layout/layout.component';
import {LoginComponent} from './account/auth/login/login.component';
import {Page404Component} from './extrapages/page404/page404.component';
import {RoleGuard} from './core/guards/role.guard';
import {DsSlotBookingComponent} from './pages/driving-school/ds-slot-booking/ds-slot-booking.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {path: 'ds/:drivingSchoolName', component: DsSlotBookingComponent},
  {path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)},
  // tslint:disable-next-line: max-line-length
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pages',
    loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule),
    canActivate: [AuthGuard, RoleGuard]
  },
  {path: '**', component: Page404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top', useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
